import React, {useMemo} from "react";
import {Transition} from "react-transition-group";
import PropTypes from "prop-types";
import {clickEvent} from "./eventStore";

const getTransitionStyles = (originScale) => {
    return {
        entering: {
            opacity: 1,
            transform: "scale(1)",
        },
        entered: {
            opacity: 1,
            transform: "scale(1)",
        },
        exiting: {
            opacity: 0,
            transform: `scale(${originScale})`,
        },
        exited: {
            opacity: 0,
            transform: `scale(${originScale})`,
        },
    };
};

// 基于React Transition Group的进离场动画组件
// 子组件需接受 style 属性
const ZoomUp = (props) => {
    const {
        children,
        visible = false,
        duration = 400,
        fromClicked = false,
        originScale = 0.2,
    } = props;

    const transitionStyles = useMemo(() => {
        return getTransitionStyles(originScale);
    }, [originScale]);

    const transformOrigin = fromClicked ? `${clickEvent.clientX ?? 0}px ${clickEvent.clientY ?? 0}px` : "center";

    return (
        <Transition
            in={visible}
            onEnter={node => node.offsetHeight}
            timeout={{
                enter: 0,
                exit: duration,
            }}
            unmountOnExit
            mountOnEnter
            appear
        >
            {
                (state) => {
                    return React.cloneElement(children, {
                        style: {
                            ...children.props.style,
                            transition: `all ${duration}ms ease`,
                            opacity: 0,
                            transform: `scale(${originScale})`,
                            transformOrigin,
                            ...transitionStyles[state],
                        },
                    });
                }
            }
        </Transition>
    );
};

ZoomUp.propTypes = {
    visible: PropTypes.bool, // react-transition-group in prop
    duration: PropTypes.number, // 过渡时间
    fromClicked: PropTypes.bool, // 从点击位置过渡动画，需在点击时通过eventStore里的方法记录点击位置
    originScale: PropTypes.number, // 初始大小比例
};

export default ZoomUp;
